var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-radio-group",
    {
      class: _vm.groupClass,
      attrs: { column: _vm.column },
      model: {
        value: _vm.modelValue,
        callback: function($$v) {
          _vm.modelValue = $$v
        },
        expression: "modelValue"
      }
    },
    _vm._l(_vm.items, function(ref) {
      var label = ref.label
      var value = ref.value
      return _c("RadioInput", {
        key: value,
        attrs: { label: label, value: value, "as-btn": true }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ae99d64c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae99d64c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/globalUiComponents/radio/RadioGroup.vue
// module id = null
// module chunks = 